// extracted by mini-css-extract-plugin
export default {"btnWrap":"styles_btnWrap__9ujVo"};